import { Country } from '@app/models';
import { CountriesActions, CountriesActionTypes, FetchCountriesSuccess } from '@app/pcs/actions/country';
import { createHandler, createReducer } from '@util';
import * as R from 'ramda';

export interface State {
  countries: Country[];
}

export const initialState: State = {
  countries: []
};

// Selectors
type GetCountries = (s: State) => Country[];
export const getCountries: GetCountries = R.prop('countries');

// Handlers
const fetchCountriesSuccess = (state: State, {payload: countries}: FetchCountriesSuccess): State => R.mergeRight(state, {countries});

const fetchCountriesSuccessHandler = createHandler(CountriesActionTypes.FetchCountriesSuccess, fetchCountriesSuccess);

export const reducer = createReducer<State, CountriesActions>([
  fetchCountriesSuccessHandler
], initialState);
